import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import translate from "i18n/translate";

const TransactionSuccessModal = ({ 
  open, 
  onClose, 
  title = "Transaction Successful", 
  message = "Your payment has been processed successfully!",
  showShareButton = false,
  showPrintButton = false,
  onShareClick = null,
  onPrintClick = null
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="transaction-success-title"
      aria-describedby="transaction-success-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="transaction-success-title" sx={{ color: 'success.main' }}>
        {typeof title === 'string' && title.trim() ? translate(title) : title || "Transaction Successful"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="transaction-success-description" sx={{ whiteSpace: 'pre-line' }}>
          {typeof message === 'string' && message.trim() ? translate(message) : message || "Your payment has been processed successfully!"}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="success" 
          sx={{ minWidth: 100 }}
        >
          {translate("OK")}
        </Button>
        {showShareButton && (
          <Button 
            onClick={onShareClick} 
            variant="outlined" 
            color="primary"
            sx={{ minWidth: 100 }}
          >
            {translate("Share")}
          </Button>
        )}
        {showPrintButton && (
          <Button 
            onClick={onPrintClick} 
            variant="outlined" 
            color="secondary"
            sx={{ minWidth: 100 }}
          >
            {translate("Print")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TransactionSuccessModal;
